import { createAction } from '@reduxjs/toolkit';
import { ITimesheet } from '../../../../dto';
import { ACT_SET, TYPE_LIST, MN_TIMESHEET } from '../../../../common';

export const setTimesheets = createAction<ITimesheet[]>(
  `${MN_TIMESHEET}/${TYPE_LIST}/${ACT_SET}`,
);
